/* global swal:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.listing_buyer', [
    ])
    .controller('ListingBuyerAdminCtrl', ListingBuyerAdminCtrl);

  /** @ngInject */
  function ListingBuyerAdminCtrl($scope, $state, $stateParams, UsersService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.username = $stateParams.username;
    vm.totalUsers = 0;
    vm.usersPerPage = 25;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1
    };

    vm.sortType = 'id-desc';
    vm.sortReverse = false;


    load(1);

    var oldSortType;
    function load(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }

      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }

      oldSortType = angular.copy(vm.sortType);
      UsersService.listListingBuyer($stateParams.parentId, vm.oldPage, 25, vm.sortType).then(success);

      function success(result){
        var items = result.results;
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        for (var i = 0; i < items.length; i++) {
          items[i].ts = new Date(parseInt(items[i].ts.toString().substring(0, items[i].ts.toString().length - 3)));
          if (items[i]['ts-m']) {
            items[i]['ts-m'] = new Date(parseInt(items[i]['ts-m'].toString().substring(0, items[i]['ts-m'].toString().length - 3)));
          }
          if (items[i]['ts-x']) {
            items[i]['ts-x'] = new Date(parseInt(items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3)));
          }
          if (items[i]['ts-sld']) {
            items[i]['ts-sld'] = new Date(parseInt(items[i]['ts-sld'].toString().substring(0, items[i]['ts-sld'].toString().length - 3)));
          }
        }

        vm.sortType = oldSortType;
        vm.items = items;
      }
    }

    vm.sort = function(type){
      vm.sortReverse = !vm.sortReverse;
      if (vm.sortReverse) {
        vm.sortType = type + '-asc';
      } else {
        vm.sortType = type + '-desc';
      }
      load(vm.pagination.current);
    };

    vm.pageChanged = function(newPage) {
      vm.sortType = oldSortType;
      load(newPage);
    };
  }

})();
